import PointAndClick from './PointAndClick.js';

import ButtonDecor from '../../prefabs/global/pointandclick/ButtonDecor.js';
import Ordi from '../../prefabs/chapitre1/ordi/Ordi.js';
import { Colors } from '../../consts/Colors.js';
import FONTS from '../../consts/Fonts.js';
import ButtonRounded from '../../prefabs/global/buttons/ButtonRounded.js';
import PopUpBlue from '../../prefabs/global/popup/PopUpBlue.js';
import ReponsePopUp from '../../prefabs/global/ordi/ReponsePopUp.js';
import QuestionPanel_1 from '../../prefabs/chapitre1/questions/QuestionPanel_01.js';
import QuestionPanel_2 from '../../prefabs/chapitre1/questions/QuestionPanel_02.js';
import QuestionPanel_3 from '../../prefabs/chapitre1/questions/QuestionPanel_03.js';
import { tags } from '../../consts/Tags.js';
import DebriefPanel from '../../prefabs/chapitre1/DebriefPanel.js';
import SoundManager from '../../prefabs/SoundManager.js';
import PopUpDecor from '../../prefabs/global/pointandclick/PopUpDecor.js';


export default class Chapitre1 extends PointAndClick {
    constructor() {
        super({
            key: "Chapitre1"
        })
    }

    init(data){
        this.audioName = 'MemoriesOfParis';
        super.init(data);   
    }

    create(){
        super.create();

        // Ajout popup d'intro
        this.popupIntro = new PopUpBlue(this, this.width/2, this.height/2, 662, 240)
        this.popupIntro.setAlpha(0);


        let introText = "Le bureau de Leïla Cercis semble en ordre.\nFouillons la pièce pour chercher des indices sur sa disparition …";
        let popupIntroText = this.add.text(0, 0, introText, {
            fontFamily: FONTS.Inter28MediumItalic,
            fontSize: '24px',
            color: Colors.Text.White,
            align: 'left',
            wordWrap: { width: 540 }
        }).setOrigin(0.5, 0);
        this.popupIntro.addElementToBody(popupIntroText, 40);

        let buttonCloseIntro = new ButtonRounded(this, 0, 0,  { 
            text: "Fouiller la pièce",
            color: Colors.Elmt.White,
            textColor: Colors.Text.Black,
            textHoverColor: Colors.Text.Blue,
            borderColor: Colors.Elmt.White,
            borderHoverColor: Colors.Elmt.Blue,
        });
        this.popupIntro.addButtonToBody(buttonCloseIntro);
        buttonCloseIntro.setClickFunction( () => {
           this.popupIntro.animOut(() => {
                this.popupIntro.destroy(true);
                this.displayButtons();
            });
        })

        this.popupIntro.animIn()
    }


    // -- Popups spécifiques --
    openIndiceSpecial(id, data){
        if(data.type == "carte_postale"){
            this.openIndiceCartePostale(id, data);
        }else if(data.type == "ordinateur"){
            this.openOrdinateur(id, data);
        }
    }

    openIndiceCartePostale(id, data){
        this.openIndice(id);

        if(!this.chapitreProgression.postale){
            this.chapitreProgression.postale = {retournee: false}
        }

        if(!this.chapitreProgression.postale.retournee){

            this.popup.setCloseButtonText("Retourner la carte")
            this.popup.setClickFunction( () => {
                this.chapitreProgression.postale.retournee = true;
                this.sauvegardeManager.updateProgression(this.scene.key, this.chapitreProgression);
                this.popup.setCloseButtonText("Fermer")
                this.popup.setBackground(data.imageKey2)
                this.tweens.add({
                    targets: this.popup.textElmt,
                    alpha: 0,
                    duration: 200,
                    onComplete: () => {
                        this.popup.setText(data.description2)
                        this.tweens.add({
                            targets: this.popup.textElmt,
                            alpha: 1,
                            duration: 200
                        })
                        this.popup.setClickFunction( () => {this.closePopup()})
                    }
                })
            })
        }else{
            this.popup.setText(data.description2)
            this.popup.setBackground(data.imageKey2)
        }
    }

    openOrdinateur(id, data){
        if(this.ordi)
            return

        this.blurBackground();

        // Close ordi si on clique en dehors
        this.background.setInteractive()
        this.background.on('pointerup', () => {
            this.closePopup();
            if(this.ordiPopup)
                this.ordiPopup.animOut(() => {
                    this.ordiPopup.destroy(true);
                    this.ordiPopup = null;
                });
            this.background.disableInteractive();
            this.background.removeListener('pointerup');
        })

        // Ajout ordinateur
        this.ordi = new Ordi(this, this.width/2, this.height)
        this.ordi.setAlpha(0)
        this.ordi.y = this.height - this.ordi.height + 50

        this.ordi.animIn(() => {
            // Change la musique
            this.soundManager.playAudio('DangerAhead')

            // Affiche l'ordi bloqué si besoin
            if(this.ordi.isLocked()){
                this.popupMDP();
            }else{
                // Affiche le panneau de question si l'ordi est débloqué
                this.addQuestionPanel();
            }
        })
    }

    // Popup à l'ouverture de l'ordi quand il est bloqué
    popupMDP(){
        this.ordiPopup = new PopUpBlue(this, this.width/2, 910, 730, 277)

        let text = "Ah mince ! Il faut un mot de passe."
        let textElmt = this.add.text(0, 0, text, {
            fontFamily: FONTS.Inter28MediumItalic,
            fontSize: '24px',
            color: Colors.Text.White,
            align: 'center',
        }).setOrigin(0.5, 0);
        this.ordiPopup.addElementToBody(textElmt, 40)

        let buttonNext = new ButtonRounded(this, 0, 0, {
            text: "Continuer de fouiller la pièce",
            color: Colors.Elmt.White,
            hoverColor: Colors.Elmt.DarkBlue,
            textColor: Colors.Text.DarkBlue,
            textHoverColor: Colors.Text.White,
            borderColor: Colors.Elmt.White,
        })
        this.ordiPopup.addButtonToBody(buttonNext, 35 + buttonNext.height/2)

        let buttonAide = new ButtonRounded(this, 0, 0, {
            text: "Besoin d'un indice ?",
            color: Colors.Elmt.DarkBlue,
            hoverColor: Colors.Elmt.White,
            textColor: Colors.Text.White,
            textHoverColor: Colors.Text.DarkBlue,
            borderColor: Colors.Elmt.White,
        })
        this.ordiPopup.addElementToBody(buttonAide, 35 + buttonAide.height/2)

        this.ordiPopup.animIn()

        buttonNext.setClickFunction( () => {
            this.ordiPopup.animOut(() => {
                this.ordiPopup.destroy(true);
                this.closePopup();
            })
        })

        buttonAide.setClickFunction( () => {
            this.ordiPopup.animOut(() => {
                this.ordiPopup.destroy(true);
                this.popupAideOrdi();
            })
        })

    }

    // Popup d'aide devant l'ordi bloqué
    popupAideOrdi(){
        this.ordiPopup = new PopUpBlue(this, this.width/2, 950, 610, 230)

        let text = "Le post-it sur la tasse semble indiquer que la\nsolution se cache dans les posters de fleurs."
        let textElmt = this.add.text(0, 0, text, {
            fontFamily: FONTS.Inter28MediumItalic,
            fontSize: '24px',
            color: Colors.Text.White,
            align: 'center',
        }).setOrigin(0.5, 0);
        this.ordiPopup.addElementToBody(textElmt, 40)

        let buttonAide = new ButtonRounded(this, 0, 0, {
            text: "Continuer de fouiller la pièce",
            color: Colors.Elmt.White,
            hoverColor: Colors.Elmt.DarkBlue,
            textColor: Colors.Text.DarkBlue,
            textHoverColor: Colors.Text.White,
            borderColor: Colors.Elmt.White,
        })
        this.ordiPopup.addButtonToBody(buttonAide, 35 + buttonAide.height/2)

        this.ordiPopup.animIn()

        buttonAide.setClickFunction( () => {
            this.ordiPopup.animOut(() => {
                this.ordiPopup.destroy(true);
                this.closePopup();
            })
        })
    }


    // Popup au débloquage de l'ordi, permet de débuter l'enquete ou de retourner à la pièce
    popupStart(){
        // MAJ progression
        this.chapitreProgression.ordi.locked = false;
        this.sauvegardeManager.updateProgression(this.scene.key, this.chapitreProgression);

        this.ordiPopup = new PopUpBlue(this, 330, this.height/2, 550, 259)
        
        let textElmt = this.add.text(0, 0, "La docteure Leïla Cercis avait l’air de s’intéresser de près à des posts viraux sur les réseaux sociaux.", {
            fontFamily: FONTS.Inter28MediumItalic,
            fontSize: '24px',
            color: Colors.Text.White,
            align: 'center',
            wordWrap: { width: 450 }, 
        }).setOrigin(0.5,0);
        this.ordiPopup.addElementToBody(textElmt, 40)

        let buttonStart = new ButtonRounded(this, 0, 0, {
            text: "Continuer",
            color: Colors.Elmt.White,
            textColor: Colors.Text.DarkBlue,
            hoverColor: Colors.Elmt.DarkBlue,
            textHoverColor: Colors.Text.White,
            borderColor: Colors.Elmt.White,
        })
        buttonStart.setClickFunction( () => {
            this.ordiPopup.animOut(() => {
                this.ordiPopup.destroy(true);
                this.ordi.unlockButtons()
                this.addQuestionPanel1();

                this.addPopUpAide("Vous pouvez cliquer sur les icônes des applications pour vous aider dans vos recherches.")
            })
        })
        this.ordiPopup.addButtonToBody(buttonStart, 35 + buttonStart.height/2)

        this.ordiPopup.animIn()
    }

    // Appelé par l'ordi quand le code est rentré correctement
    closePopupOrdi(endFunc){
        if(this.ordiPopup == null || this.ordiPopup == undefined) return;

        if(this.popupAide)
            this.popupAide.animOut(() => {
                this.popupAide.destroy(true);
                this.popupAide = null;
            })

        this.ordiPopup.animOut(() => {
            this.ordiPopup.destroy(true);
            this.ordiPopup = null;
            if(endFunc)
                endFunc();
        })
    }

    addQuestionPanel(){
        const num = this.chapitreProgression.ordi.question
        switch(num){
            case 1:
                this.addQuestionPanel1()
                break;
            case 2:
                this.addQuestionPanel2()
                break;
            case 3:
                this.addQuestionPanel3()
                break;
        }
    }

    // Panneau de question qui s'ouvre une fois l'enquete débutée
    addQuestionPanel1(){
        this.chapitreProgression.ordi.question = 1;
        this.sauvegardeManager.updateProgression(this.scene.key, this.chapitreProgression);
        this.questionPanel = new QuestionPanel_1(this, 0, 0, {config: this.config.questions[0], totQuestion: this.config.questions.length})
        this.questionPanel.depth = 999
        this.questionPanel.animIn();
    }

    addQuestionPanel2(){
        this.chapitreProgression.ordi.question = 2;
        this.sauvegardeManager.updateProgression(this.scene.key, this.chapitreProgression);
        this.questionPanel = new QuestionPanel_2(this, 0, 0, {config: this.config.questions[1], totQuestion: this.config.questions.length})
        this.questionPanel.depth = 999
        this.questionPanel.animIn();
    }

    addQuestionPanel3(){
        this.chapitreProgression.ordi.question = 3;
        this.sauvegardeManager.updateProgression(this.scene.key, this.chapitreProgression);
        this.questionPanel = new QuestionPanel_3(this, 0, 0, {config: this.config.questions[2], totQuestion: this.config.questions.length})
        this.questionPanel.depth = 999
        this.questionPanel.animIn();
    }

    addDebrief(){
        this.debrief = new DebriefPanel(this)
        this.debrief.depth = 100
        this.debrief.animIn();
    }

    closeDebrief(){
        this.debrief.destroy(true);

        this.closePopup()
        this.time.addEvent({
            delay: 500,
            callback: () => {
                let txt = 'Les indices parlent d’eux-mêmes : Leïla ne s’est pas contentée de lire ces posts viraux, son œil de botaniste y a décelé des failles. Elle a cherché des réponses en contactant un confrère de l’Institut Botanique de Rio qui prétendait détenir des preuves décisives.\n\nLa carte postale sur son bureau confirme son départ : elle espérait dissiper ses doutes, même si cette invitation tombait presque trop à point nommé.\n\n<class=\"Inter28BoldItalic\">En route pour Rio de Janeiro, la Cidade Maravilhosa !</class>'
                this.popupFinChapitre(txt, 660, "DebutChapitre2");
            }
        })
    }

    closePanelQuestion(endFunc){
        if(this.questionPanel == null || this.questionPanel == undefined) return;

        // Ferme le panneau de question
        this.questionPanel.animOut(() => {
            this.questionPanel.destroy(true);
            this.questionPanel = null;

            if(endFunc)
                endFunc(this);
        })
    }



}